/* Built in imports */
import React, { Component } from 'react';

/* Third party imports */
import Slider from '@appigram/react-rangeslider';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

/* Internal imports */
import YesInputWithoutReduxForm from '../../../../form/InputWithoutReduxForm';
import { TransHtmlText } from '../../../../yes/utils/TransHtmlText';
import { YesCheckboxV2 } from '../../../../form/CheckboxV2';
import { isCumulPercoiAbondementUnilateralEnabled } from '../../../../../services/TenantService';
import { nombre, nombreSansEspaces } from '../../../../../common/FunctionsUtils';
import { plafondAbondementPERCO, plafondAbondementUnilateral } from '../../../../../modules/simulateur/fonctions';

export class AbondementUnilateralForm extends Component {
  isError = false;

  constructor(props) {
    super(props);
    this.changerValeurSlider = this.changerValeurSlider.bind(this);
    this.changerValeurInput = this.changerValeurInput.bind(this);
    this.state = {
      showPlafondPassAbnUnilateral: true
    };
  }

  componentDidMount() {
    this.props.change('abnUnilateral', false);
    this.props.change('periodiqueMontant', 0);
    this.props.change('amorcageMontant', 0);

    // On set les valeurs persistées s'ils elles existent
    const abnUnilateral = this.props.tunnel.dossier.dispositifs.dispositifPercoi.abondementUnilateral;
    if (abnUnilateral) {
      if (abnUnilateral.miseEnPlace) {
        this.props.change('abnUnilateral', true);
        if (abnUnilateral.periodiqueMontant) {
          this.props.change('periodiqueMontant', abnUnilateral.periodiqueMontant);
        }
        if (abnUnilateral.amorcageMontant) {
          this.props.change('amorcageMontant', abnUnilateral.amorcageMontant);
        }

        if (!abnUnilateral.plafondPass) {
          if (!isCumulPercoiAbondementUnilateralEnabled()) {
            if (abnUnilateral.periodiqueMontant && abnUnilateral.periodiqueMontant > this.getPlafondPercoi()) {
              this.props.change('periodiqueMontant', this.getPlafondPercoi());
            } else if (abnUnilateral.amorcageMontant && abnUnilateral.amorcageMontant > this.getPlafondPercoi()) {
              this.props.change('amorcageMontant', this.getPlafondPercoi());
            }
          }
        }
      } else {
        this.props.change('abnUnilateral', false);
        this.setState({
          showPlafondPassAbnUnilateral: false
        });
      }
    }
  }

  /**
   * Si feature abondement unilatéral intégré dans les 16% du percoi
   * on calcule le max ici.
   * Si feature non activée, on retourne directement le plafond autorisé
   * @returns {*}
   */
  getPlafondPercoi = () => {
    if (isCumulPercoiAbondementUnilateralEnabled()) {
      return plafondAbondementUnilateral(this.props.tunnel.dossier);
    }

    //Si pas de paliers, on retourne 0 à l'abondement
    if (!this.props.tunnel.dossier.dispositifs.dispositifPercoi.abondement) {
      return plafondAbondementUnilateral(this.props.tunnel.dossier);
    }

    if (plafondAbondementPERCO() - this.props.plafondPercoi < plafondAbondementUnilateral(this.props.tunnel.dossier)) {
      return plafondAbondementPERCO() - this.props.plafondPercoi;
    }
    return plafondAbondementUnilateral(this.props.tunnel.dossier);
  };

  getMaxPaliersAbondement = (paliers) => {
    let plafond = 0;
    if (paliers && paliers.length > 1) {
      for (let index in paliers) {
        let palier = paliers[index];
        if (palier.versementMax > 0) {
          plafond += (palier.versementMax - palier.versementMin) * palier.taux;
        }
      }
    } else {
      plafond = paliers && paliers[0] && paliers[0].versementMax;
    }
    return plafond;
  };

  afficherMessagePlafondAbondementUnilateralDansPercoi = () => {
    if (isCumulPercoiAbondementUnilateralEnabled()) {
      return false;
    }

    return (
      this.getPlafondPercoi() < plafondAbondementUnilateral(this.props.tunnel.dossier) &&
      this.props.plafondAbnUnilateral === this.getPlafondPercoi() &&
      this.props.showContent
    );
  };

  choixSelectionne() {
    return this.props.abondementUnilateralForm && this.props.abondementUnilateralForm.values.abnUnilateral;
  }

  changerValeurSlider = (type) => (value) => {
    this.changerValeur(value, type);
  };

  changerValeurInput = (type) => (event) => {
    if (event.target.validity.valid) {
      const value = nombre(nombreSansEspaces(event.target.value));
      this.changerValeur(value, type);
    }
  };

  changerValeur = (value, type) => {
    let valueAbnUnilateral = value === '' ? 0 : value;
    if (valueAbnUnilateral > plafondAbondementUnilateral(this.props.tunnel.dossier)) {
      valueAbnUnilateral = plafondAbondementUnilateral(this.props.tunnel.dossier);
    }
    if (Number(value) > plafondAbondementUnilateral(this.props.tunnel.dossier)) {
      valueAbnUnilateral = plafondAbondementUnilateral(this.props.tunnel.dossier);
      this.isError = true;
    }
    this.props.change(type, valueAbnUnilateral);
    this.setState({
      showPlafondPassAbnUnilateral: valueAbnUnilateral >= plafondAbondementUnilateral(this.props.tunnel.dossier)
    });
    this.isError = false;
  };

  getMessagePlafondRestant = () => {
    const plafond = plafondAbondementUnilateral(this.props.tunnel.dossier);
    const periodique = Number(this.props.periodiqueMontant) || 0;
    const amorcage = Number(this.props.amorcageMontant) || 0;
    const format = (montant) => `${Number(montant).toLocaleString('fr-FR')} €`;

    if (amorcage + periodique > plafond) {
      return `La première année, l'abondement d'amorçage sera de ${format(amorcage)} et l'abondement périodique annuel de ${format(plafond - amorcage)} pour respecter le plafond de ${format(plafond)}.`;
    }
    return null;
  };

  render() {
    return (
      <>
        <div className={`grid-x grid-margin-x ${this.props.disabled}`}>
          <div className="cell medium-12">
            <div className="tunnelRadios">
              <div className="tunnelRadio">
                <Field
                  name="abnUnilateral"
                  component={YesCheckboxV2}
                  type="checkbox"
                  id="abnUnilateral"
                  labeltext={<TransHtmlText i18nKey="abn.unilateral.question.miseEnPlace" params={{ config: this.props.config }} />}
                />
              </div>
            </div>
            {this.props.showContent && (
              <div className="alignContentGrid">
                <div className="alignContentRowGrid">
                  <div className="yes-label">
                    Plafond d’abondement périodique annuel (max {plafondAbondementUnilateral(this.props.tunnel.dossier)}€)
                  </div>
                  <div className={`cell sliderDispositifAbondement`}>
                    <Slider
                      value={this.props.periodiqueMontant || '0'}
                      orientation="horizontal"
                      onChange={this.changerValeurSlider('periodiqueMontant')}
                      tooltip={false}
                      max={this.getPlafondPercoi()}
                    />
                    {`${((+this.props.periodiqueMontant * 100) / this.props.PASS).toFixed(2)} %`}
                    {this.state.showPlafondPassAbnUnilateral && isCumulPercoiAbondementUnilateralEnabled() && (
                      <span className="infoMaxSlider">{plafondAbondementUnilateral(this.props.tunnel.dossier)} €</span>
                    )}
                  </div>
                  <div className={`plafondAbondementInput`}>
                    <YesInputWithoutReduxForm
                      value={this.props.periodiqueMontant || '0'}
                      onChange={this.changerValeurInput('periodiqueMontant')}
                      euroField={true}
                    />
                  </div>
                </div>
                <div className="alignContentRowGrid">
                  <div className="yes-label">
                    Plafond d’abondement d’amorcage (max {plafondAbondementUnilateral(this.props.tunnel.dossier)}€)
                  </div>
                  <div className={`cell sliderDispositifAbondement`}>
                    <Slider
                      value={this.props.amorcageMontant || '0'}
                      orientation="horizontal"
                      onChange={this.changerValeurSlider('amorcageMontant')}
                      tooltip={false}
                      max={this.getPlafondPercoi()}
                    />
                    {`${((+this.props.amorcageMontant * 100) / this.props.PASS).toFixed(2)} %`}
                    {this.state.showPlafondPassAbnUnilateral && isCumulPercoiAbondementUnilateralEnabled() && (
                      <span className="infoMaxSlider">{plafondAbondementUnilateral(this.props.tunnel.dossier)} €</span>
                    )}
                  </div>
                  <div className={`plafondAbondementInput`}>
                    <YesInputWithoutReduxForm
                      value={this.props.amorcageMontant || '0'}
                      onChange={this.changerValeurInput('amorcageMontant')}
                      euroField={true}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {this.props.showContent && this.getMessagePlafondRestant() && (
          <p className="errorMsgTauxDegressif">{this.getMessagePlafondRestant()}</p>
        )}
        {(this.afficherMessagePlafondAbondementUnilateralDansPercoi() || this.isError) && (
          <h3 className="msgInfoAbondementUnilateralDansPercoi">
            Vous ne pouvez pas dépasser ce plafond car l&#39;abondement ne peut excéder 16% du PASS au total sur le PERCOL(i).
          </h3>
        )}
      </>
    );
  }
}

// REDUX + REDUX FORM
const mapDispatchToProps = () => ({});
// eslint-disable-next-line no-class-assign
AbondementUnilateralForm = reduxForm({ form: 'dispositifAbondementForm' })(AbondementUnilateralForm);
const selectAbondementUnilateralForm = formValueSelector('dispositifAbondementForm');
// eslint-disable-next-line no-class-assign
AbondementUnilateralForm = connect((state) => {
  const periodiqueMontant = selectAbondementUnilateralForm(state, 'periodiqueMontant');
  const amorcageMontant = selectAbondementUnilateralForm(state, 'amorcageMontant');
  const tunnel = state.tunnel;
  const abondementUnilateralForm = state.form.abondementUnilateralForm;
  return {
    abondementUnilateralForm,
    periodiqueMontant,
    amorcageMontant,
    tunnel
  };
}, mapDispatchToProps)(AbondementUnilateralForm);

export default AbondementUnilateralForm;
